import logoUrl from "@/assets/favicon-source.svg";
import { cn } from "@/lib/utils";

type LogoProps = {
  /** Hoogte/breedte in pixels. Default 32. */
  size?: number;
  /** Extra Tailwind/util classes (bijv. flex-shrink-0). */
  className?: string;
  /**
   * Toegankelijke naam. Weglaten = puur decoratief: render dan met
   * lege alt en aria-hidden zodat schermlezers het overslaan.
   */
  alt?: string;
};

export function Logo({ size = 32, className, alt }: LogoProps) {
  const decoratief = alt === undefined;
  return (
    <img
      src={logoUrl}
      alt={decoratief ? "" : alt}
      aria-hidden={decoratief || undefined}
      width={size}
      height={size}
      style={{ width: size, height: size }}
      className={cn("inline-block", className)}
      draggable={false}
    />
  );
}
